export const camelCaseToTitleCase = (camelCase: string): string => {
    return camelCase
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/^./, (match) => match.toUpperCase());
};